import React from 'react';
import { Container, Menu, Segment } from 'semantic-ui-react';
import { Link, useLocation } from 'react-router-dom';

function AdminLayout({ children }) {
  const location = useLocation();

  return (
    <Container>
      <Segment vertical>
        <Menu secondary pointing>
          <Menu.Item
            as={Link}
            to="/admin/users"
            active={location.pathname === '/admin/users'}
          >
            Users
          </Menu.Item>
          <Menu.Item
            as={Link}
            to="/admin/oils"
            active={location.pathname === '/admin/oils'}
          >
            Oils
          </Menu.Item>
        </Menu>
        {children}
      </Segment>
    </Container>
  );
}

export default AdminLayout; 